module.exports = __webpack_public_path__ + "authorization.a56cef87650fc1549d96c9543f969539.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/menu/selected/authorization.svg
// module id = 340
// module chunks = 0